<template>
  <div class="ws-search-bar"></div>
</template>

<script>
export default {};
</script>

<style>
</style>